import { withRouter } from 'react-router-dom'
import useCadastroEstoque, { LOAD_MESSAGE, getMenuItems } from './CadastroEstoqueHook'
import { connect } from 'react-redux'
import { ConfirmDialog, CustomPanel, PageHeader, ThreeDots } from '../../../../components'
import React, { useEffect } from 'react'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import ModalCadastroEstoque from './ModalCadastroEstoque'
import ModalFotografiaEstoque from './ModalFotografiaEstoque'
import { FaTrash } from 'react-icons/fa'

function CadastroEstoque({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useCadastroEstoque()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.FILTERING:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getEstoque(selectedTp)
        break

      case LOAD_MESSAGE.DELETE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.deleteEstoque(selectedTp, state.selectedEstoque.id)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(hideLoadingBox())
      dispatch(showMessageBox(state.successMessage, null))
      localDispatch.resetState()
    }
  }, [state.successMessage])

  useEffect(() => {
    if (state.pathToRedirect) {
      history.push(state.pathToRedirect, { selectedEstoque: state.selectedEstoque })
    }
  }, [state.pathToRedirect])

  return (
    <div>
      <PageHeader>8.1 - Cadastro de Estoque</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.onBtnNovo(selectedTp)}
          showBtnNovo={selectedTp}
          onVoltar={history.goBack}
        >
          <>
            <div className="p-grid" style={{ marginBottom: 20 }}>
              <div className="p-col-12">
                <DataTable value={state.estoques} emptyMessage="Não existe estoque cadastrado">
                  <Column field="id" header="Código" style={tableCellCentered(80)} />
                  <Column field="name" header="Nome" />
                  <Column
                    header="Menu"
                    style={tableCellCentered(70)}
                    body={estoque => (
                      <ThreeDots
                        items={getMenuItems()}
                        onClick={item => localDispatch.onMenuItemClicked(item, estoque, selectedTp)}
                      />
                    )}
                    bodyStyle={tableCellCentered()}
                  />
                  {localDispatch.verifyMenuItemAllowed({ id: 51, content: '2. Apagar' }) && (
                    <Column
                      header=""
                      style={tableCellCentered(70)}
                      body={estoque => (
                        <FaTrash
                          style={{ cursor: 'pointer' }}
                          color="red"
                          onClick={() =>
                            localDispatch.onMenuItemClicked('2. Apagar', estoque, selectedTp)
                          }
                        />
                      )}
                      bodyStyle={tableCellCentered()}
                    />
                  )}
                </DataTable>
              </div>
            </div>
          </>
        </CustomPanel>
      </div>
      <ModalCadastroEstoque
        data={state.modal.data}
        show={state.modal.show === '1. Editar' || state.modal.show === 'Novo'}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        tpId={selectedTp}
      />
      <ModalFotografiaEstoque
        estoque={state.modalFotografia.data}
        show={state.modalFotografia.show}
        onModalClose={localDispatch.onModalFotografiaClose}
        onModalSave={localDispatch.onModalFotografiaSave}
        tpId={selectedTp}
      />
      <ConfirmDialog
        isVisible={state.modalConfirmDelete.show}
        title="Atenção"
        content={<span>Tem certeza que deseja excluir o estoque?</span>}
        onCancelar={localDispatch.onModalDeleteClose}
        onOk={() => localDispatch.onModalDeleteSave(state.modalConfirmDelete.data)}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CadastroEstoque))
